export default __webpack_public_path__ + "static/media/508.f1747ba0.gif";